import {
  AlertTriangle,
  CheckCircle2,
  Clock,
  FileText,
  Gavel,
  Mailbox,
  PenLine,
  Scale,
  Send,
  ShieldAlert,
  Building2,
} from "lucide-react";
import type { DisputeRound, Letter } from "./api";

// One glyph per letter kind so operators scan the Letters list visually.
// Falls back to a generic document for anything unmapped.
export function letterKindIcon(kind: Letter["kind"], size = 16) {
  const map: Record<string, React.ReactNode> = {
    "605b": <ShieldAlert size={size} aria-hidden="true" />,
    late_payment: <Clock size={size} aria-hidden="true" />,
    bureau_dispute: <Scale size={size} aria-hidden="true" />,
    creditor_direct: <Building2 size={size} aria-hidden="true" />,
    debt_validation: <Gavel size={size} aria-hidden="true" />,
    method_of_verification: <Scale size={size} aria-hidden="true" />,
    reinvestigation: <Scale size={size} aria-hidden="true" />,
    public_records_dispute: <Gavel size={size} aria-hidden="true" />,
    lexisnexis_dispute: <Building2 size={size} aria-hidden="true" />,
    section_623_dispute: <ShieldAlert size={size} aria-hidden="true" />,
    manual: <FileText size={size} aria-hidden="true" />,
  };
  return map[kind] ?? <FileText size={size} aria-hidden="true" />;
}

// Status glyph + tone for a dispute round: drafting → ready → mailed →
// response-due → complete. Tone drives the row-icon color (warn/good/neutral).
export function disputeStatusIcon(
  status: DisputeRound["status"],
  size = 16,
): { icon: React.ReactNode; tone: "" | "warn" | "good" } {
  switch (status) {
    case "drafting":
      return { icon: <PenLine size={size} aria-hidden="true" />, tone: "" };
    case "ready":
      return { icon: <Send size={size} aria-hidden="true" />, tone: "" };
    case "mailed":
      return { icon: <Mailbox size={size} aria-hidden="true" />, tone: "" };
    case "response_due":
      return { icon: <AlertTriangle size={size} aria-hidden="true" />, tone: "warn" };
    case "partially_complete":
      return { icon: <Clock size={size} aria-hidden="true" />, tone: "" };
    case "complete":
      return { icon: <CheckCircle2 size={size} aria-hidden="true" />, tone: "good" };
    default:
      return { icon: <FileText size={size} aria-hidden="true" />, tone: "" };
  }
}
